import {
    APP_INITIALIZER,
    ApplicationConfig,
    importProvidersFrom,
    provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';

import { environment } from 'src/environments/environment';

import { GoogleMapsLoaderService } from 'src/shared/services/google-maps-loader/google-maps-loader.service';
import { SecureSimpleStorage } from 'src/shared/services/storage/secure-simple-storage';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { dataSourceSecureFactory } from 'src/shared/services/storage/data-source-secure.factory';
import { CrReqRes } from 'src/shared/services/storage/crReqRes';

// initializer normal
export function initializeGoogleMaps(gmapsService: GoogleMapsLoaderService) {
    return () => gmapsService.loadGoogleMaps(environment.apigoogle);
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: false }),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),

        ...(!environment?.isForzaCourierPack
            ? [
                  {
                      provide: APP_INITIALIZER,
                      useFactory: initializeGoogleMaps,
                      deps: [GoogleMapsLoaderService],
                      multi: true,
                  },
                  GoogleMapsLoaderService,
              ]
            : []),

        {
            provide: SecureSimpleStorage,
            useFactory: dataSourceSecureFactory,
            deps: [CrReqRes],
        },
        CrReqRes,

        importProvidersFrom(BrowserAnimationsModule),
    ],
};
